
export function isNoSubscriptionFoundError(error: { status?: number } | null | undefined): boolean {
  return error?.status === 404;
}
